import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/dashboard-shell";
import { PartnerDetailView } from "@/components/partner-detail-view";
import { Route as RootRoute } from "./__root";

export const Route = createFileRoute("/partners/$partnerId")({
  component: PartnerDetailPage,
});

function PartnerDetailPage() {
  const { user } = RootRoute.useRouteContext();
  const { partnerId } = Route.useParams();
  return (
    <DashboardShell userLabel={user?.displayName || user?.loginName || ""}>
      <PartnerDetailView partnerId={partnerId} />
    </DashboardShell>
  );
}
